// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1fpml","title":"ClientCherryInfo_title__3Kw-G","itemText":"ClientCherryInfo_itemText__1NRtn"};